<script setup lang="ts">
import ClaimInvoiceDialog from '@/components/asicw/claim-invoices/ClaimInvoiceDialog.vue'
import InvoicesTable from '@/components/asicw/tables/ClaimInvoicesTable.vue'
import { useOIDCStore } from '@/stores/oidc.store'
import ViewLayout from '@/views/layouts/ViewLayout.vue'
import { Plus } from '@element-plus/icons-vue'
import { ref } from 'vue'

const { isASICWManagerUser } = useOIDCStore()

const createClaimInvoiceDialogOpen = ref<boolean>(false)

const handleCreateClaimInvoices = () => {
  createClaimInvoiceDialogOpen.value = true
}
</script>

<template>
  <ViewLayout>
    <InvoicesTable />
    <template #controls>
      <el-button v-if="isASICWManagerUser" type="primary" :icon="Plus" @click="handleCreateClaimInvoices"
        >Create Claim Invoice</el-button
      >
    </template>

    <ClaimInvoiceDialog v-if="createClaimInvoiceDialogOpen" v-model="createClaimInvoiceDialogOpen" />
  </ViewLayout>
</template>
